<template>
  <b-modal
    id="admin-switch-form-modal"
    :title="trans('switch_form')"
    :ok-title="trans('switch')"
    :ok-disabled="busy"
    :cancel-title="trans('cancel')"
    @shown="onShown"
    @ok="onSwitch"
  >
    <b-form-group>
      <model-treeselect
        :organization="organization"
        :url="`/organization/${this.organization.id}/checkout_form/list?per_page=100`"
        :multiple="false"
        v-model="form_id"
        :placeholder="trans('form')"
        :disabled="busy"
      ></model-treeselect>
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import ModelTreeselect from './../../../common/components/ModelTreeselect'

  export default {
    props: {
      organization: Object,
      invoice: Object,
    },
    components: {
      ModelTreeselect,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        form_id: this.invoice.checkout_forms.length > 0 ?
          this.invoice.checkout_forms[0].form.id :
          null
      }
    },
    methods: {
      onShown() {
        this.form_id = this.invoice.checkout_forms.length > 0 ?
          this.invoice.checkout_forms[0].form.id :
          null
      },
      onSwitch(e) {
        e.preventDefault()
        let url = `/org/${this.organization.id}/cart/switch_form/${this.invoice.ucid}`
        this.busy = true
        this.error = null
        axios.patch(url, {form_id: this.form_id})
        .then(response => {
          this.busy = false
          this.$bvModal.hide('admin-switch-form-modal')
          this.$emit('invoice', response.data)
          //window.location = window.location.href.split('#')[0] + '#form'
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      }
    },
    mounted() {
      window.adminSwitchFormModal = this
    },
  }
</script>